/// <amd-module name="Build/Common/Library/Sources/Build" />
import { IVssPageContext } from "VSS/Platform/Context";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
import {
    Build
} from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IGetBuildsOptions } from "./Build.types";
import { IXAMLBuildRestClient } from  "Build/Client/XAMLClient"
export interface IBuildSourceOptions {
    pageContext: IVssPageContext;
    project: string;
}

const s_defaultCount = 50;

export class BuildSource {
    private _client: IBuildRestClient;
    private _XAMLclient: IXAMLBuildRestClient;
    private _project: string;

    constructor(options: IBuildSourceOptions) {
        this._client = options.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
        this._XAMLclient = options.pageContext.getRestClient<IXAMLBuildRestClient>("IXAMLBuildRestClient");
        this._project = options.project;
    }

    public getBuild(buildId: number): Promise<Build> {
        return this._client.getBuild(this._project, buildId);
    }

    public getBuilds(filter: IGetBuildsOptions): Promise<Build[]> {
        return this._client.getBuilds(
            filter.project || this._project,
            filter.definitions,
            filter.queues,
            filter.buildNumber,
            filter.minTime,
            filter.maxTime,
            filter.requestedFor,
            filter.reasonFilter,
            filter.statusFilter,
            filter.resultFilter,
            filter.tagFilters,
            filter.properties,
            filter.top || s_defaultCount,
            filter.continuationToken,
            filter.maxBuildsPerDefinition,
            filter.deletedFilter,
            filter.queryOrder,
            filter.branchName,
            filter.buildIds,
            filter.repositoryId,
            filter.repositoryType            
        );
    }

    public getXAMLBuilds(filter: IGetBuildsOptions): Promise<Build[]> {
        return this._XAMLclient.getXAMLBuilds(
            filter.project || this._project,
            filter.definitions,
            filter.queues,
            filter.buildNumber,
            filter.minTime,
            filter.maxTime,
            filter.requestedFor,
            filter.reasonFilter,
            filter.statusFilter,
            filter.resultFilter,
            filter.tagFilters,
            filter.properties,
            filter.top || s_defaultCount,
            filter.continuationToken,
            filter.maxBuildsPerDefinition,
            filter.deletedFilter,
            filter.queryOrder,
            filter.branchName,
            filter.buildIds,
            filter.repositoryId,
            filter.repositoryType,
            filter.type
           
        );
    }

    public getClient(): IBuildRestClient
    {
        return this._client;
        
    }
    
}
